import { lazy } from "react";

import { orchestrationPathResources } from "../../orchestrationPaths";
import IVRRouter from "../IvrRouter";
import { IVRPaths } from "../paths";

import type { RegalRouteObject } from "App/routes/types";

const IVRList = lazy(() => import("./IVRListPage/IVRListPage"));
const IVREditPage = lazy(() => import("./IVREditPage/IVREditPage"));

export const ivrRoute: RegalRouteObject = {
    path: `${orchestrationPathResources.ivrs}/*`,
    element: <IVRRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <IVRList />,
        },
        {
            path: IVRPaths.ivrDetail,
            element: <IVREditPage />,
        },
    ],
};
